import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useState, useEffect } from 'react';
import { CircularProgress, Divider } from '@mui/material';
import toast from 'react-hot-toast';
import axios from './../../../axios/api';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '0.2px solid #eee',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
    direction: 'ltr'
};

const DelBannerModal = ({ open, handleCloseModal, id, refreshData }) => {
    const [openModal, setOpenModal] = useState(open);
    const [isLoading, setIsLoading] = useState(false);
    const [LoadingIntial, setLoadingIntial] = useState(false);
    const [Title, setTitle] = useState('');

    const handleClose = () => {
        setOpenModal(false);
        handleCloseModal();

    };

    useEffect(() => {
        getDataSelected();
    }, [id])
    const getDataSelected = async () => {
        try {
            setLoadingIntial(true);
            let url = `/admin/ad/show/${id}`;
            const res = await axios.get(url);
            setTitle(res.data?.data?.title);
        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setLoadingIntial(false);
        }
    };

    const DeleteBanner = async () => {
        setIsLoading(true);
        try {
            const res = await axios.delete(`/admin/ad/destroy/${id}`);
            toast.success(res.data?.message);
            handleClose();
            refreshData();
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {LoadingIntial ?
                    <Box mt={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center" >
                        <CircularProgress size={24} color="inherit" />
                    </Box>
                    :
                    <>
                        <Typography variant='h4' textAlign="left">حذف بنر</Typography>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant='caption'>آیا مایل به حذف "{Title}" هستید؟</Typography>

                        <Box mt={2} display="flex" flexDirection="row-reverse" gap={1}>
                            <Button onClick={handleClose} color="redColor" variant="outlined" size="large" disabled={isLoading}>
                                <Typography variant='button' color="#d90429">بستن</Typography>
                            </Button>
                            <Button onClick={DeleteBanner} color="redColor" variant="contained" size="large" disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <Typography variant='button' color="White">حذف</Typography>}
                            </Button>
                        </Box>

                    </>

                }
            </Box>
        </Modal>
    );
}
export default DelBannerModal;